export function setUser(payload) {
  return {
    type: "SET_USER",
    payload,
  };
}

export function fetchDataLocation() {
  return {
    type: "FETCH_DATA_LOCATION",
  };
}

export function fetchDataCategoryProduct() {
  return {
    type: "FETCH_DATA_CATEGORY_PRODUCT",
  };
}

export function fetchDataService() {
  return {
    type: "FETCH_DATA_SERVICE",
  };
}

export function fetchDataBrand() {
  return {
    type: "FETCH_DATA_BRAND",
  };
}

export function fetchDataProduct() {
  return {
    type: "FETCH_DATA_PRODUCT",
  };
}

export function fetchDataAboutUs() {
  return {
    type: "FETCH_DATA_ABOUT",
  };
}

export function fetchDataNews() {
  return {
    type: "FETCH_DATA_NEWS",
  };
}
export function fetchDataBlog(page = 0) {
  return {
    type: "FETCH_DATA_BLOG",
    payload: { page },
  };
}

export function fetchDetailBlog(slug) {
  return {
    type: "FETCH_DETAIL_BLOG",
    payload: { slug },
  };
}

export function fetchDataEvent() {
  return {
    type: "FETCH_DATA_EVENT",
  };
}

export function fetchBanner() {
  return {
    type: "FETCH_DATA_BANNER",
  };
}

export function fetchMetaTag() {
  return {
    type: "FETCH_DATA_META_TAG",
  };
}
export function fetchMerkAc() {
  return {
    type: "FETCH_DATA_MERK_AC",
  };
}
export function fetchDataTipeModel(payload) {
  return {
    type: "FETCH_DATA_TIPE_MODEL",
    payload,
  };
}
